import React, { useEffect, useState } from "react"

const MESSAGES: string[] = [
  "uplink://online · region us-east · latency 47ms",
  "build://main@f440f74 · ci passed · 12s",
  "cluster://5 nodes · cpu 23% · mem 41%",
  "vector-store://2.4M embeddings · p95 14ms",
  "ai-agent://opus-4.7 · context 1M · streaming",
  "deploy://prod · canary green · 0 errors",
]

const StatusBar: React.FC = () => {
  const [idx, setIdx] = useState<number>(0)

  useEffect(() => {
    const t = setInterval(() => {
      setIdx(i => (i + 1) % MESSAGES.length)
    }, 4200)
    return () => clearInterval(t)
  }, [])

  return (
    <div className="status-bar" aria-live="polite">
      <span className="status-pulse" aria-hidden="true" />
      <span className="status-prompt">$</span>
      <span className="status-message" key={idx}>
        {MESSAGES[idx]}
      </span>
      <span className="status-caret" aria-hidden="true" />
    </div>
  )
}

export default StatusBar
